<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight Grid


  CodeSample(name="Default" :pug="defaultPug" :html="defaultHtml" )
    .grid
      .column
        .button.is-block 1
      .column
        .button.is-block 2
      .column
        .button.is-block 3
      .column
        .button.is-block 4
  CodeSample(name="Columns" :pug="columnsPug" :html="columnsHtml" class="u-mt-md")
    .grid
      .column.is-2
        label.label.is-block.is-secondary .is-2
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-3
        label.label.is-block.is-secondary .is-3
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-4
        label.label.is-block.is-secondary .is-4
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-5
        label.label.is-block.is-secondary .is-5
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-6
        label.label.is-block.is-secondary .is-6
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-7
        label.label.is-block.is-secondary .is-7
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-8
        label.label.is-block.is-secondary .is-8
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-9
        label.label.is-block.is-secondary .is-9
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-10
        label.label.is-block.is-secondary .is-10
      .column.is-1
        label.label.is-block 1
      .column.is-1
        label.label.is-block 1
    .grid
      .column.is-11
        label.label.is-block.is-secondary .is-11
      .column.is-1
        label.label.is-block 1






  CodeSample(name="Offset" :pug="offsetPug" :html="offsetHtml" class="u-mt-md")
    .grid
      .column.is-4.is-offset-4
        .button.is-block .is-4.is-offset-4
    .grid
      .column.is-6.is-offset-3
        .button.is-block .is-6.is-offset-3
    .grid
      .column.is-5.is-offset-7
        .button.is-block .is-5.is-offset-7
    .grid
      .column.is-11.is-offset-1
        .button.is-block .is-11.is-offset-1

  CodeSample(name="Shrink" :pug="shrinkPug" :html="shrinkHtml" class="u-mt-md")
    .grid.is-shrink
      .column
        .button.is-block Columns take only the size
      .column
        .button.is-block of their content
      .column
        .button.is-block with class
      .column
        .button.is-block .is-shrink
  CodeSample(name="Relaxed" :pug="relaxedPug" :html="relaxedHtml" class="u-mt-md")
    .grid.is-relaxed
      .column
        .button.is-block Removes gutters
      .column
        .button.is-block.is-secondary between columns
      .column
        .button.is-block with class
      .column
        .button.is-block.is-secondary .is-relaxed
  CodeSample(name="Horizontal alignment" :pug="startPug" :html="startHtml" class="u-mt-md")
    .grid.is-start
      .column.is-4
        .button.is-block is-start

    .grid.is-center
      .column.is-4
        .button.is-block is-center

    .grid.is-end
      .column.is-4
        .button.is-block is-end

  CodeSample(name="Vertical alignment" :pug="verticalPug" :html="verticalHtml" class="u-mt-md")
    .demoVertical-grid
      .grid.is-top.is-relaxed
        .column
          .button.is-block is-top
        .column
          .button.is-block is-top

      .grid.is-middle.is-relaxed
        .column
          .button.is-block is-middle
        .column
          .button.is-block is-middle

      .grid.is-bottom.is-relaxed
        .column
          .button.is-block is-bottom
        .column
          .button.is-block is-bottom








  h5.u-mt-md Grid modifiers
  .grid.is-widescreen-7.is-desktop-8.is-tablet-9
    .column
      p.u-mb-xs Choose between different modifiers to adjust how columns are displayed in the grid.
  table.table.is-relaxed
    thead
      tr
        th Modifier
        th Description
        th Value
    tbody
      tr
        td shrink
        td columns take only the size of their content
        td .is-shrink
      tr
        td relaxed
        td removes gutters between columns
        td .is-relaxed
      tr
        td start
        td align columns to the start of the grid
        td .is-start
      tr
        td center
        td align columns to the center of the grid
        td .is-center
      tr
        td end
        td align columns to the end of the grid
        td .is-end
      tr
        td vertical
        td arrange columns in a vertical order
        td .is-vertical

  h5.u-mt-md Column width modifiers
  .grid.is-widescreen-7.is-desktop-8.is-tablet-9
    .column
      p.u-mb-xs Adjust the width and offset of columns on different devices.
  table.table.is-relaxed
    thead
      tr
        th Modifier
        th Description
        th Value
    tbody
      tr
        td mobile
        td you can change the column width from #[span.u-cl-secondary 0] to #[span.u-cl-secondary 767px]
        td .is-mobile-

      tr
        td tablet
        td you can change the column width from #[span.u-cl-secondary 768px] to #[span.u-cl-secondary 990px]
        td .is-tablet-

      tr
        td desktop
        td you can change the column width from #[span.u-cl-secondary 991px] to #[span.u-cl-secondary 1359px]
        td .is-desktop-

      tr
        td widescreen
        td you can change the column width from #[span.u-cl-secondary 1360px] to #[span.u-cl-secondary 1919px]
        td .is-widescreen-

      tr
        td ultrawide
        td you can change the column width from #[span.u-cl-secondary 1920px] to #[span.u-cl-secondary up]
        td .is-ultrawide-
  p.u-cl-secondary Note: you can use .is-[$number] instead of .is-mobile-[$number], as a shorthand.
  h5.u-mt-md Column Offset modifiers
  .grid.is-widescreen-7.is-desktop-8.is-tablet-9
    .column
      p.u-mb-xs Adjust the width and offset of columns on different devices.
  table.table.is-relaxed
    thead
      tr
        th Modifier
        th Description
        th Value
    tbody
      tr
        td mobile
        td
          p you can change the column offset from #[span.u-cl-secondary 0] to #[span.u-cl-secondary 767px]

        td
          | .is-offset-mobile-
      tr
        td tablet
        td
          p you can change the column offset from #[span.u-cl-secondary 768px] to #[span.u-cl-secondary 990px]

        td
          | .is-offset-tablet-
      tr
        td desktop
        td
          p you can change the column offset from #[span.u-cl-secondary 991px] to #[span.u-cl-secondary 1359px]

        td
          | .is-offset-desktop-
      tr
        td widescreen
        td
          p you can change the column offset from #[span.u-cl-secondary 1360px] to #[span.u-cl-secondary 1919px]

        td
          | .is-offset-widescreen-
      tr
        td ultrawide
        td
          p you can change the column offset from #[span.u-cl-secondary 1920px] to #[span.u-cl-secondary up]
        td
          | .is-offset-ultrawide-

</template>

<script>
import CodeSample from '~/components/CodeSample';

export default {
  scrollToTop: true,
  layout: 'base',
  head: () => ({
    title: 'Grid'
  }),
  components: {
    CodeSample
  },
  data: () => ({
    defaultPug: `.grid
  .column
    .button.is-block 1
  .column
    .button.is-block 2
  .column
    .button.is-block 3
  .column
    .button.is-block 4`,
    defaultHtml: `<div class="grid">
  <div class="column">
    <div class="button is-block">1</div>
  </div>
  <div class="column">
    <div class="button is-block">2</div>
  </div>
  <div class="column">
    <div class="button is-block">3</div>
  </div>
  <div class="column">
    <div class="button is-block">4</div>
  </div>
</div>`,
    columnsPug: `.grid
  .column.is-2
    label.label.is-block.is-primary .is-2
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-3
    label.label.is-block.is-primary .is-3
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-4
    label.label.is-block.is-primary .is-4
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-5
    label.label.is-block.is-primary .is-5
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-6
    label.label.is-block.is-primary .is-6
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-7
    label.label.is-block.is-primary .is-7
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-8
    label.label.is-block.is-primary .is-8
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-9
    label.label.is-block.is-primary .is-9
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-10
    label.label.is-block.is-primary .is-10
  .column.is-1
    label.label.is-block 1
  .column.is-1
    label.label.is-block 1


.grid
  .column.is-11
    label.label.is-block.is-primary .is-11
  .column.is-1
    label.label.is-block 1`,
    columnsHtml: `<div class="grid">
  <div class="column is-2">
    <label class="label is-block is-primary">.is-2</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-3">
    <label class="label is-block is-primary">.is-3</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-4">
    <label class="label is-block is-primary">.is-4</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-5">
    <label class="label is-block is-primary">.is-5</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-6">
    <label class="label is-block is-primary">.is-6</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-7">
    <label class="label is-block is-primary">.is-7</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-8">
    <label class="label is-block is-primary">.is-8</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-9">
    <label class="label is-block is-primary">.is-9</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-10">
    <label class="label is-block is-primary">.is-10</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>


<div class="grid">
  <div class="column is-11">
    <label class="label is-block is-primary">.is-11</label>
  </div>
  <div class="column is-1">
    <label class="label is-block">1</label>
  </div>
</div>`,
    offsetPug: `.grid
  .column.is-4.is-offset-4
    .button.is-block .is-4.is-offset-4

.grid
  .column.is-6.is-offset-3
    .button.is-block .is-6.is-offset-3

.grid
  .column.is-5.is-offset-7
    .button.is-block .is-5.is-offset-7

.grid
  .column.is-11.is-offset-1
    .button.is-block .is-11.is-offset-1`,
    offsetHtml: `<div class="grid">
  <div class="column is-4 is-offset-4">
    <div class="button is-block">.is-4.is-offset-4</div>
  </div>
</div>

<div class="grid">
  <div class="column is-6 is-offset-3">
    <div class="button is-block">.is-6.is-offset-3</div>
  </div>
</div>

<div class="grid">
  <div class="column is-5 is-offset-7">
    <div class="button is-block">.is-5.is-offset-7</div>
  </div>
</div>

<div class="grid">
  <div class="column is-11 is-offset-1">
    <div class="button is-block">.is-11.is-offset-1</div>
  </div>
</div>`,
    shrinkPug: `.grid.is-shrink
  .column
    .button.is-block Columns take only the size
  .column
    .button.is-block of their content
  .column
    .button.is-block with class
  .column
    .button.is-block .is-shrink`,
    shrinkHtml: `<div class="grid is-shrink">
  <div class="column">
    <div class="button is-block">Columns take only the size</div>
  </div>
  <div class="column">
    <div class="button is-block">of their content</div>
  </div>
  <div class="column">
    <div class="button is-block">with class </div>
  </div>
  <div class="column">
    <div class="button is-block">.is-shrink</div>
  </div>
</div>`,
    relaxedPug: `.grid.is-relaxed
  .column
    .button.is-block Removes gutters
  .column
    .button.is-block.is-primary between columns
  .column
    .button.is-block with class
  .column
    .button.is-block.is-primary .is-relaxed`,
    relaxedHtml: `<div class="grid is-relaxed">
  <div class="column">
    <div class="button is-block">Removes gutters</div>
  </div>
  <div class="column">
    <div class="button is-block is-primary">between columns</div>
  </div>
  <div class="column">
    <div class="button is-block">with class </div>
  </div>
  <div class="column">
    <div class="button is-block is-primary">.is-relaxed</div>
  </div>
</div>`,
    startPug: `.grid.is-start
  .column.is-4
    .button.is-block is-start

.grid.is-center
  .column.is-4
    .button.is-block is-center

.grid.is-end
  .column.is-4
    .button.is-block is-end`,
    startHtml: `<div class="grid is-start">
  <div class="column is-4">
    <div class="button is-block">is-start</div>
  </div>
</div>

<div class="grid is-center">
  <div class="column is-4">
    <div class="button is-block">is-center</div>
  </div>
</div>

<div class="grid is-end">
  <div class="column is-4">
    <div class="button is-block">is-end</div>
  </div>
</div>`,
    verticalPug: `.grid.is-top.is-relaxed
  .column
    .button.is-block is-top
  .column
    .button.is-block is-top

.grid.is-middle.is-relaxed
  .column
    .button.is-block is-middle
  .column
    .button.is-block is-middle

.grid.is-bottom.is-relaxed
  .column
    .button.is-block is-bottom
  .column
    .button.is-block is-bottom`,
    verticalHtml: `<div class="grid is-top is-relaxed">
  <div class="column">
    <div class="button is-block">is-top</div>
  </div>
  <div class="column">
    <div class="button is-block">is-top</div>
  </div>
</div>
<div class="grid is-middle is-relaxed">
  <div class="column">
    <div class="button is-block">is-middle</div>
  </div>
  <div class="column">
    <div class="button is-block">is-middle</div>
  </div>
</div>
<div class="grid is-bottom is-relaxed">
  <div class="column">
    <div class="button is-block">is-bottom</div>
  </div>
  <div class="column">
    <div class="button is-block">is-bottom</div>
  </div>
</div>`
  })
};
</script>

<style lang="stylus">
.demoVertical-grid
  .grid
    min-height: 300px
    background: lighten($clGray, 60%)
    margin-bottom: unitRes(20, 40)

  .button
    margin: 0
</style>
